var _rect, _path, _path2, _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAlumniSpace = function SvgAlumniSpace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FF855F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.909 20.706c-3.61 0-6.58 2.8-6.936 6.389-.04.4.29.726.691.726h12.49c.402 0 .731-.327.692-.726-.357-3.589-3.326-6.39-6.937-6.39Z",
    fill: "url(#alumni-space_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.554 15.824a3.644 3.644 0 1 1-7.289 0 3.644 3.644 0 0 1 7.289 0Z",
    fill: "url(#alumni-space_svg__b)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.919 24.219a7.083 7.083 0 0 0-2.401-2.479c.858-1.592 2.517-2.67 4.424-2.67 2.546 0 4.651 1.923 4.997 4.424.055.398-.276.725-.678.725H26.92Z",
    fill: "url(#alumni-space_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.942 18.174a2.638 2.638 0 1 0 0-5.275 2.638 2.638 0 0 0 0 5.275Z",
    fill: "url(#alumni-space_svg__d)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.899 24.22a7.085 7.085 0 0 1 2.4-2.48c-.858-1.591-2.517-2.67-4.423-2.67-2.546 0-4.652 1.923-4.998 4.424-.054.398.277.725.678.725H14.9Z",
    fill: "url(#alumni-space_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.876 18.174a2.638 2.638 0 1 1 0-5.276 2.638 2.638 0 0 1 0 5.276Z",
    fill: "url(#alumni-space_svg__f)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alumni-space_svg__a",
    x1: 21.655,
    y1: 13.699,
    x2: 15.938,
    y2: 27.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alumni-space_svg__b",
    x1: 21.655,
    y1: 13.699,
    x2: 15.939,
    y2: 27.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alumni-space_svg__c",
    x1: 31.339,
    y1: 12.898,
    x2: 26.235,
    y2: 22.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alumni-space_svg__d",
    x1: 31.34,
    y1: 12.898,
    x2: 26.235,
    y2: 22.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alumni-space_svg__e",
    x1: 10.478,
    y1: 12.898,
    x2: 15.583,
    y2: 22.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alumni-space_svg__f",
    x1: 10.478,
    y1: 12.898,
    x2: 15.583,
    y2: 22.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))));
};

export default SvgAlumniSpace;